import styled from 'styled-components';
import { noop } from 'utils/noop';
import { Select } from 'ui/selectv2/Select';
import { FlexSpacer } from 'ui/flexSpacer';
import { CATALOG_NAME } from 'modules/catalog/catalogConstants';
import { selectCatalogsAsDropdownOptions } from 'modules/catalogTable/selectors';
import { Body2 } from 'ui/theme';

const StyledLabel = styled.div`
  font-weight: 600;
  min-width: 100px;
`;

type CatalogsDropdownProps = {
  /** this is the redux state prop "state.catalogs.tables.dataObj" converted into dropdown options */
  catalogs: ReturnType<typeof selectCatalogsAsDropdownOptions>;
  disabled?: boolean;
  isLoading?: boolean;
  onChange: (catalogName: string) => void;
  value: string;
};

export const CatalogsDropdown = ({
  catalogs = [],
  disabled = false,
  isLoading = false,
  onChange = noop,
  value,
  ...props
}: CatalogsDropdownProps) => {
  const selectedDropdownValue = catalogs.find((catalog) => catalog.value === value);

  return (
    <FlexSpacer {...props}>
      <StyledLabel>Catalog</StyledLabel>
      {disabled ? (
        <Body2 data-test="catalogs-dropdown-disabled-state">{value}</Body2>
      ) : (
        <Select
          isLoading={isLoading}
          onSelect={([selectedCatalog]) => onChange(selectedCatalog.value)}
          options={catalogs}
          placeholder={`Select a ${CATALOG_NAME}`}
          usePortal
          value={[selectedDropdownValue]}
        />
      )}
    </FlexSpacer>
  );
};
